<template>
    <ModalBase
        :name="name"
        title="Editar nombre de la familia"
        width="500"
        @close="cancel"
    >
        <div class="tw:flex tw:flex-col tw:gap-3">
            <BaseInputText
                label="Nombre de la familia"
                name="nombre_familia"
                :value="nombre"
                placeholder="Nombre del grupo familiar"
                @input="emitNombre"
            />
            <span v-if="error" class="tw:text-xs tw:text-red-500">{{ error }}</span>
        </div>

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button variant="ghost" :disabled="loading" @click="cancel">Cancelar</Button>
                <Button
                    variant="primary"
                    :disabled="!canSubmit"
                    @click="submit"
                >
                    {{ loading ? 'Guardando...' : 'Guardar' }}
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { computed, getCurrentInstance } from 'vue'
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        name: { type: String, required: true },
        nombre: { type: String, default: '' },
        original: { type: String, default: '' },
        loading: { type: Boolean, default: false },
        error: { type: String, default: null },
    })

    const emit = defineEmits(['update:nombre', 'submit', 'close'])
    const instance = getCurrentInstance()

    const trimmed = computed(() => (props.nombre || '').trim())

    const canSubmit = computed(() => {
        if (props.loading) return false
        if (!trimmed.value) return false
        if (trimmed.value === (props.original || '').trim()) return false
        return true
    })

    function emitNombre(value) {
        emit('update:nombre', value)
    }

    function submit() {
        if (!canSubmit.value) return
        emit('submit', trimmed.value)
    }

    function cancel() {
        instance.proxy.$modal.hide(props.name)
        emit('close')
    }
</script>
